import type { SaveUserProfileRequestProps } from '@services/api/users/types'
import type { UserDataFormProps } from '../components/UserDataModal/components/RegistrationDataForm/form/types'

export const parseSaveUserProfilePayload = (formData: UserDataFormProps) => {
  const payload: SaveUserProfileRequestProps = {
    routeParams: {
      id: formData?.id!
    },
    bodyParams: {
      profileId: formData.profileDescription as unknown as number
    }
  }

  return payload
}
